module.exports = __webpack_public_path__ + "static/media/mgp_salud.5526ed16.png";